module.exports = __webpack_public_path__ + "img/collection-weddingRingsMillgrif@2x.5bffed9.webp";